// @flow
import { createAction } from 'redux-actions';

export const setGlobal = (message) => ({
  type: 'PL_GLOBAL_ERROR',
  payload: { message },
});

export const clearGlobalErrorAction = createAction('CLEAR_GLOBAL_ERROR');
